import { render, staticRenderFns } from "./ServiceUnits.vue?vue&type=template&id=f5128116&scoped=true&"
import script from "./ServiceUnits.vue?vue&type=script&lang=js&"
export * from "./ServiceUnits.vue?vue&type=script&lang=js&"
import style0 from "./ServiceUnits.vue?vue&type=style&index=0&id=f5128116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5128116",
  null
  
)

export default component.exports